'use client';

import IconClose from '@/fo/icons/base/icons/close10.svg';
import IconSearch from '@/fo/icons/base/icons/search.svg';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { UiKitInputSearch } from '@/fo/ui/kit/input/search';

import { styles } from './UiKitDrawerSearch.styles';

export interface BaseSuggestion {
  value: string;
  id: string;
  region: string;
  cityPure: string;
}

export type Suggestion<T extends object = object> = BaseSuggestion & T;

export interface UiKitDrawerSearchProps<T extends object = object> {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title: string;
  subtitle?: string;
  value: string;
  onChange: (value: string) => void;
  suggestions: Suggestion<T>[];
  onSuggestionClick?: (suggestion: Suggestion<T>) => void;
  className?: string;
  direction?: 'left' | 'right';
  loading?: boolean;
  autoFocus?: boolean;
}

export function UiKitDrawerSearch<T extends object = object>({
  open,
  onOpenChange,
  title,
  subtitle,
  value,
  onChange,
  suggestions,
  onSuggestionClick,
  className,
  direction = 'right',
  loading,
  autoFocus = true
}: UiKitDrawerSearchProps<T>) {
  const slots = styles();

  return (
    <UiKitDrawerBase
      title={title}
      open={open}
      onOpenChange={onOpenChange}
      className={className}
      withoutMobile
      direction={direction}
    >
      <div className={slots.header()}>
        <div className={slots.title()}>{title}</div>
        {subtitle && <div className={slots.subtitle()}>{subtitle}</div>}
      </div>
      <UiKitInputSearch
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={autoFocus}
        startAdornment={<IconSearch />}
        endAdornment={
          value.length > 0 && (
            <span
              onClick={() => onChange('')}
              className={slots.inputClear()}
            >
              <IconClose className={slots.inputClearIcon()} />
            </span>
          )
        }
      />
      {!!suggestions.length && (
        <ul className={slots.suggestions()}>
          {suggestions.map((item) => (
            <li
              key={item.id ?? item.value}
              className={slots.suggestion()}
              onClick={() => onSuggestionClick?.(item)}
            >
              {item.value}
            </li>
          ))}
        </ul>
      )}
      {loading && (
        <div className={slots.loadingContainer()}>
          <div className={slots.loading()} />
        </div>
      )}
    </UiKitDrawerBase>
  );
}
